exports = module.exports = require("../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._37oqVBvtOwtpfFkpAy8Tsa{position:fixed;z-index:5;left:0;top:0;width:101%;height:101%;overflow:auto;background-color:rgba(0,0,0,0.4)}._1WypQ1pIscstis3UPJpNoG{background-color:#fff;width:80%;max-width:300px;position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);-ms-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}._34RKlupi274wE_hoSLCJ-m{margin-bottom:1.5rem}\n", ""]);

// exports
exports.locals = {
	"modal": "_37oqVBvtOwtpfFkpAy8Tsa",
	"modalContent": "_1WypQ1pIscstis3UPJpNoG",
	"illustration": "_34RKlupi274wE_hoSLCJ-m"
};